import(/* webpackMode: "eager", webpackExports: ["LandingContent"] */ "/vercel/path0/apps/web/src/components/landing/LandingContent.tsx");
